import type { ExposedMenu } from '@moniebook-web/components/widgets/sidebar';

import { accountingMenu } from './accounting-ui';
import { businessMgtMenu } from './business-mgt-ui';
import { customersMenu } from './customers-ui';
import { dashboardMenu } from './dashboard-ui';
import { inventoryOnboardingMenu } from './inventory-onboarding-ui';
import { onboardingMenu } from './onboarding-ui';
import { ordersMenu } from './orders-ui';
import { productsMenu } from './products-ui';
import { registersMenu } from './registers-ui';
import { reportsMenu } from './reports-ui';
import { saleSettingsMenu } from './sale-settings-ui';
import { settingsMenu } from './settings-ui';

export const staticMenus: ExposedMenu[] = [
    dashboardMenu,
    businessMgtMenu,
    settingsMenu,
    accountingMenu,
    customersMenu,
    inventoryOnboardingMenu,
    onboardingMenu,
    ordersMenu,
    registersMenu,
    reportsMenu,
    saleSettingsMenu,
    productsMenu,
];
